import { DarkThemeContext } from 'ci-esi-web-shared';
import { useContext, useLayoutEffect } from 'react';
import Cookies from 'universal-cookie';

import { IMPACT_FEATURE_FLAGS } from 'utils/cookie';

// Parent app (e.g. Immerse) may use different cookie names
const FEATURE_FLAG_COOKIES = [IMPACT_FEATURE_FLAGS, 'ImpactFeatureFlag', 'impactFeatureFlag', 'impactFeatureToggle'];
const STANDALONE_DARK_MODE_COOKIE = 'isDarkModeEnabled';

function parseThemeFromCookie(): boolean | null {
  const cookies = new Cookies();

  // Check standalone isDarkModeEnabled cookie (value "true" or "false")
  const standalone = cookies.get(STANDALONE_DARK_MODE_COOKIE);
  if (standalone !== undefined && standalone !== null) {
    const str = String(standalone).toLowerCase();
    if (str === 'true') return true;
    if (str === 'false') return false;
  }

  // Check JSON cookies (e.g. {"isDarkModeEnabled": true})
  for (const name of FEATURE_FLAG_COOKIES) {
    const value = cookies.get(name);
    if (value) {
      try {
        const parsed = typeof value === 'string' ? JSON.parse(value) : value;
        if (typeof parsed?.isDarkModeEnabled === 'boolean') {
          return parsed.isDarkModeEnabled;
        }
      } catch {
        // ignore parse errors
      }
    }
  }

  return null;
}

/**
 * Syncs theme with ImpactFeatureFlag / impactFeatureFlags cookie on mount.
 * The ThemeProvider from ci-esi-web-shared may not read the cookie on init;
 * this ensures dark mode is applied when isDarkModeEnabled: true is set.
 */
export function DarkModeInitializer({ children }: { children: React.ReactNode }) {
  const { setDarkMode } = useContext(DarkThemeContext);

  useLayoutEffect(() => {
    const isDarkModeEnabled = parseThemeFromCookie();
    if (isDarkModeEnabled !== null) {
      setDarkMode(isDarkModeEnabled);
    }
  }, [setDarkMode]);

  return <>{children}</>;
}
